import { DoubleDownArrowsIcon } from '@verbit-ai/icons-library'

import { usePrefersReducedMotion } from 'src/hooks/usePrefersReducedMotion'
import { HOTKEYS } from 'src/utils/hotkeys'

import * as S from './styles'

type ScrollButtonProps = {
    onClick: () => void
    autoScrollMode: boolean
    hasIndicator: boolean
    isAttentionPulsing?: boolean
}

export const getScrollButtonAccessibleName = (autoScrollMode: boolean): string => {
    const action = autoScrollMode ? 'Pause autoscroll' : 'Resume autoscroll'

    return `${action} (${HOTKEYS.toggleAutoscroll.presentation})`
}

export const ScrollButton = (props: ScrollButtonProps) => {
    const { onClick, autoScrollMode, hasIndicator, isAttentionPulsing = false } = props
    const prefersReducedMotion = usePrefersReducedMotion()
    const accessibleName = getScrollButtonAccessibleName(autoScrollMode)
    const shouldPulse = isAttentionPulsing && !prefersReducedMotion

    return (
        <S.Button
            type="button"
            onClick={onClick}
            tabIndex={0}
            title={accessibleName}
            aria-label={accessibleName}
            aria-keyshortcuts={HOTKEYS.toggleAutoscroll.ariaKeyshortcuts}
            data-autoscroll-active={autoScrollMode ? 'true' : undefined}
            data-attention-pulsing={shouldPulse ? 'true' : undefined}
            data-has-indicator={!autoScrollMode && hasIndicator ? 'true' : undefined}>
            <DoubleDownArrowsIcon size={20} color="currentColor" />
        </S.Button>
    )
}
